export default __webpack_public_path__ + "static/media/appempleoscusco.a169e717.png";